import React from 'react'
import { Modal, Button, Form, Select, DatePicker, Input, theme } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const ScheduleSurgeryModal = ({
  isModalVisible,
  handleCancel,
  handleAdd,
  form,
  surgeryTypes,
  surgeons,
  surgeryRooms
}) => {
  const { token } = theme.useToken()

  return (
    <Modal
      title='Schedule New Surgery'
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={[
        <Button
          key='cancel'
          onClick={handleCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={handleAdd}
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Schedule Surgery
        </Button>
      ]}
      width={700}
    >
      <Form form={form} layout='vertical'>
        <Form.Item name='patientId' label='Patient' rules={[{ required: true, message: 'Please select a patient' }]}>
          <Select placeholder='Select patient' showSearch optionFilterProp='children'>
            <Option value='PT-1001'>John Smith (PT-1001)</Option>
            <Option value='PT-1023'>Emma Wilson (PT-1023)</Option>
            <Option value='PT-1045'>Michael Brown (PT-1045)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='surgeryType'
          label='Surgery Type'
          rules={[{ required: true, message: 'Please select surgery type' }]}
        >
          <Select placeholder='Select surgery type'>
            {surgeryTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='scheduledDateTime'
          label='Scheduled Date/Time'
          rules={[{ required: true, message: 'Please specify date and time' }]}
        >
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name='duration'
          label='Duration (minutes)'
          rules={[{ required: true, message: 'Please enter expected duration' }]}
        >
          <Input type='number' min={15} step={15} />
        </Form.Item>

        <Form.Item
          name='assignedSurgeon'
          label='Surgeon'
          rules={[{ required: true, message: 'Please select surgeon' }]}
        >
          <Select placeholder='Select surgeon'>
            {surgeons.map((surgeon) => (
              <Option key={surgeon} value={surgeon}>
                {surgeon}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='anaesthesiologist'
          label='Anaesthesiologist'
          rules={[{ required: true, message: 'Please select anaesthesiologist' }]}
        >
          <Select placeholder='Select anaesthesiologist'>
            <Option value='Dr. Daniel Wright'>Dr. Daniel Wright</Option>
            <Option value='Dr. Emma Taylor'>Dr. Emma Taylor</Option>
            <Option value='Dr. Amanda Parker'>Dr. Amanda Parker</Option>
            {/* More options would be populated from staff database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='surgeryRoom'
          label='Theatre'
          rules={[{ required: true, message: 'Please select operating theatre' }]}
        >
          <Select placeholder='Select theatre'>
            {surgeryRooms.map((room) => (
              <Option key={room} value={room}>
                {room}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='urgency' label='Urgency' rules={[{ required: true, message: 'Please select urgency level' }]}>
          <Select placeholder='Select urgency'>
            <Option value='Emergency'>Emergency</Option>
            <Option value='Urgent'>Urgent</Option>
            <Option value='Elective'>Elective</Option>
          </Select>
        </Form.Item>

        <Form.Item name='preparationNotes' label='Preparation Notes'>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ScheduleSurgeryModal
